import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { URLS } from '@wix/da-url';
import { BiData, TopNavMenuClickBiEvent } from '@wix/da-bi/pkg/events';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { SessionContext } from '@wix/da-react-context/pkg/publicSession';
import type { MenuItem } from '@wix/da-ds/pkg/Dropdown/MenuList';
import { UserMenuContext } from '../UserMenuMobile/UserMenuContext';

export function useHelpItem(): MenuItem & { key: string } {
  const { t } = useTranslation();
  const { isLoggedIn } = useContext(SessionContext);
  const { isOpen: isUserMenuOpen } = useContext(UserMenuContext);
  const isMobile = useContext(MobileContext);

  return {
    key: 'help',
    label: t('siteHeader.userMenu.helpAndFAQ'),
    link: URLS.HELP,
    target: !isMobile && isLoggedIn ? '_blank' : undefined,
    biData: BiData<TopNavMenuClickBiEvent>({
      evid: 702,
      link_url: URLS.HELP,
      menu_item: isMobile ? 'help' : 'help_and_faq',
      menu_name: 'profile',
    }),
    tabIndex: isUserMenuOpen || !isMobile ? 0 : -1,
  };
}
